import React, { PureComponent } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Page G",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

export default class Example extends PureComponent {
  static demoUrl = "https://codesandbox.io/s/simple-line-chart-kec3v";

  render() {
    let newData = [];
    for (let index = 0; index < this.props.dataList.length; index++) {
      const element = this.props.dataList[index];
      newData.push({ consumption: parseFloat(element.consumption) });
    }
    return (
      <ResponsiveContainer width="100%" height={250}>
        <LineChart
          data={newData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis tickCount={20} dataKey="consumption" />
          <Tooltip
            formatter={(value) => {
              let newVal = new Intl.NumberFormat("en").format(value);
              return <span style={{ fontWeight: "bold" }}>{newVal}</span>;
            }}
          />

          <Legend />
          <Line
            strokeWidth={2}
            type="monotone"
            dataKey="consumption"
            stroke="#3498db"
          />
          {/* <Line
            strokeWidth={1.5}
            activeDot={{ r: 8 }}
            type="monotone"
            dataKey="Accomplishment"
            stroke="#27ae60"
          />
          <Line
            strokeWidth={1.5}
            activeDot={{ r: 8 }}
            type="monotone"
            dataKey="Assigned"
            stroke="#3498db"
          />
          <Line
            strokeWidth={1.5}
            activeDot={{ r: 8 }}
            type="monotone"
            dataKey="Remaining"
            stroke="#f39c12"
          /> */}
        </LineChart>
      </ResponsiveContainer>
    );
  }
}
